<div class="row" *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
  <div class="col-12">
    <sb-card>
      <div card-header>

      </div>
      <div card-header-more>
        <sb-comp-chart-control (dateChange)="setTimeFrame($event)" (intervalChange)="setInterval($event)"
                               (filterChange)="setPlayerCulls($event)" [from]="from"
                               [till]="till"></sb-comp-chart-control>
      </div>
    </sb-card>
  </div>
  <div class="col-6"
       *ngIf="permissionService.hasPermission(permissionService.Permission.channel_list) && permissionService.hasPermission(permissionService.Permission.cull_list)">
    <sb-comp-channel-airtime-quota></sb-comp-channel-airtime-quota>
  </div>
  <div class="col-6">
    <sb-comp-airtime-data *ngIf="!loading"
                          [chartHeight]="350" [resolveInCom]="false"
                          [from]="from" [till]="till"
                          [inputData]="timeFrameData" [integratedChart]="false" [halfHeight]="false"
    ></sb-comp-airtime-data>
  </div>
</div>
